import { InputGroup } from 'react-bootstrap'
import { v4 } from 'uuid'

export default function NamedCheckbox({ name, onChange, value, defaultValue }) {
	const id = v4();
	return (
		<InputGroup className="mb-3">
			<InputGroup.Checkbox onChange={onChange} id={id} checked={value} defaultValue={defaultValue} />
			<label className="input-group-text" style={{ flex : '1 1 auto' }} htmlFor={id}>{name}</label>
		</InputGroup>
	)
}
